import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CustomerService } from '@marina/api-client';
import { PortalCustomerContextService } from '../services/portal-customer-context.service';

/** Blocks Dockhand portal users from account-owner routes (billing, authorized-users). */
export const blockDockhandGuard: CanActivateFn = () => {
  const portalContext = inject(PortalCustomerContextService);
  const customerService = inject(CustomerService);
  const router = inject(Router);

  return portalContext.ensureLoaded(customerService).pipe(
    map(() => {
      if (portalContext.isDockhand) {
        void router.navigate(['/dashboard']);
        return false;
      }
      return true;
    })
  );
};
